let TKL = '0816'
let TUL = '0810'
let GKL = '0192'
let GUL = '0197'

export default {TKL, TUL, GKL, GUL}